import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import CountUp from "react-countup";
import { STATS } from "../../data/content";

function Reveal({ children, delay = 0 }) {
  return (
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.33, 1, 0.68, 1] }}>
      {children}
    </motion.div>
  );
}

export default function About() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Reveal>
            <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 01 — WHO WE ARE</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl md:text-5xl leading-[0.95]">
              A logistics network<br />engineered for<br /><span className="text-primary">motion.</span>
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <Reveal delay={0.15}>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Conexa Relay was built on a simple belief: freight should never wait. For over a decade we've
              connected manufacturers, retailers and pharma leaders across North America with a fleet that
              treats every mile as a promise.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              From temperature-critical cold-chain to permitted heavy haul, we combine seasoned drivers with
              a real-time control tower — so you always know exactly where your cargo is, and when it lands.
            </p>
          </Reveal>
        </div>
      </div>

      <div ref={ref} className="max-w-7xl mx-auto mt-24 grid grid-cols-1 sm:grid-cols-3 gap-8">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div data-testid={`stat-${i}`} className="border-t border-border pt-6">
              <div className="font-heading font-extrabold text-5xl md:text-6xl tracking-tighter text-primary">
                {inView && <CountUp end={s.value} duration={2.2} decimals={s.decimals || 0} />}{s.suffix}
              </div>
              <div className="mt-3 text-sm text-muted-foreground font-mono-x tracking-wide">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
